import { render, staticRenderFns } from "./MDeviceTypePercentagePanel.vue?vue&type=template&id=54280355&scoped=true"
import script from "./MDeviceTypePercentagePanel.vue?vue&type=script&lang=js"
export * from "./MDeviceTypePercentagePanel.vue?vue&type=script&lang=js"
import style0 from "./MDeviceTypePercentagePanel.vue?vue&type=style&index=0&id=54280355&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54280355",
  null
  
)

export default component.exports